/* ============================================================
   GRILLPRO · premium interactions
   reveal · sticky bar · FAQ · before/after · count-up
   ============================================================ */
(function () {
  if (window.__GRILLPRO__) return;
  window.__GRILLPRO__ = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll(".gp-reveal:not([data-seen])");
    if (!("IntersectionObserver" in window) || reduce) {
      els.forEach(function (e) { e.classList.add("is-in"); e.setAttribute("data-seen", "1"); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e, i) {
      e.setAttribute("data-seen", "1");
      var g = e.getAttribute("data-stagger");
      if (g) e.style.setProperty("--d", (parseInt(g, 10) * 80) + "ms");
      io.observe(e);
    });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = (el.getAttribute("data-count").split(".")[1] || "").length;
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.firstChild.nodeValue = (target * e).toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (p < 1) requestAnimationFrame(step); else el.firstChild.nodeValue = target.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    requestAnimationFrame(step);
  }
  function counts(root) {
    var els = (root || document).querySelectorAll("[data-count]:not([data-done])");
    if (!("IntersectionObserver" in window) || reduce) { els.forEach(function (e) { e.setAttribute("data-done", "1"); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { countUp(x.target); x.target.setAttribute("data-done", "1"); io.unobserve(x.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  function faq(root) {
    (root || document).querySelectorAll(".gp-faq__q:not([data-f])").forEach(function (q) {
      q.setAttribute("data-f", "1");
      q.addEventListener("click", function () {
        var item = q.closest(".gp-faq__item");
        var ans = item.querySelector(".gp-faq__a");
        var open = item.classList.toggle("is-open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        ans.style.maxHeight = open ? ans.scrollHeight + "px" : null;
      });
    });
  }

  function pdpSticky(root) {
    var bar = (root || document).querySelector("[data-gp-pdp-sticky]");
    if (!bar || bar.getAttribute("data-on")) return;
    bar.setAttribute("data-on", "1");
    var cta = document.querySelector(".gp-pdp__cta");
    function check() {
      if (!cta) return;
      var r = cta.getBoundingClientRect();
      bar.classList.toggle("is-on", r.bottom < 0 || r.top > window.innerHeight);
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
  }

  function sticky(root) {
    var bar = (root || document).querySelector(".gp-sticky:not([data-gp-pdp-sticky])");
    if (!bar || bar.getAttribute("data-on")) return;
    bar.setAttribute("data-on", "1");
    var hero = document.querySelector(".gp-hero");
    var final = document.querySelector(".gp-final");
    function check() {
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      var atEnd = final ? final.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle("is-on", past && !atEnd);
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
  }

  function beforeAfter(root) {
    (root || document).querySelectorAll(".gp-ba:not([data-ba])").forEach(function (ba) {
      ba.setAttribute("data-ba", "1");
      var after = ba.querySelector(".gp-ba__after");
      var handle = ba.querySelector(".gp-ba__handle");
      var dragging = false;
      function setPos(clientX) {
        var r = ba.getBoundingClientRect();
        var p = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
        ba.style.setProperty("--pos", p + "%");
      }
      function down(e) { dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); }
      function move(e) { if (dragging) setPos((e.touches ? e.touches[0] : e).clientX); }
      function up() { dragging = false; }
      ba.addEventListener("mousedown", down); ba.addEventListener("touchstart", down, { passive: true });
      window.addEventListener("mousemove", move); window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", up); window.addEventListener("touchend", up);
      ba.style.setProperty("--pos", "50%");
    });
  }

  function anchors(root) {
    (root || document).querySelectorAll("a[data-gp-scroll]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var t = document.querySelector(a.getAttribute("href"));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); }
      });
    });
  }

  function qty(root) {
    (root || document).querySelectorAll("[data-gp-qty]:not([data-q])").forEach(function (q) {
      q.setAttribute("data-q", "1");
      var input = q.querySelector("[data-qty-input]");
      var m = q.querySelector("[data-qty-minus]"), p = q.querySelector("[data-qty-plus]");
      function v() { return Math.max(1, parseInt(input.value, 10) || 1); }
      if (m) m.addEventListener("click", function () { input.value = Math.max(1, v() - 1); });
      if (p) p.addEventListener("click", function () { input.value = v() + 1; });
    });
  }

  function stickySubmit(root) {
    var b = (root || document).querySelector("[data-gp-sticky-add]");
    var form = document.getElementById("gp-product-form");
    if (b && form && !b.getAttribute("data-s")) {
      b.setAttribute("data-s", "1");
      b.addEventListener("click", function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  function gallery(root) {
    (root || document).querySelectorAll("[data-gp-gallery]:not([data-g])").forEach(function (g) {
      g.setAttribute("data-g", "1");
      var main = g.querySelector("[data-gp-main]");
      var thumbs = g.querySelectorAll("[data-gp-thumb]");
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          var src = t.getAttribute("data-src");
          if (main && src) main.setAttribute("src", src);
          thumbs.forEach(function (x) { x.classList.remove("is-active"); });
          t.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- reviews (client-side store) ---------- */
  function starsSvg(filled) {
    var s = "";
    for (var i = 1; i <= 5; i++) {
      s += '<svg viewBox="0 0 24 24" fill="currentColor" style="color:' + (i <= filled ? "var(--star)" : "var(--border)") + '"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>';
    }
    return s;
  }
  function esc(t) { var d = document.createElement("div"); d.textContent = t; return d.innerHTML; }
  var GP_RKEY = "gp_reviews_v1";
  function gpLoad() { try { return JSON.parse(localStorage.getItem(GP_RKEY)) || []; } catch (e) { return []; } }
  function gpSave(a) { try { localStorage.setItem(GP_RKEY, JSON.stringify(a)); } catch (e) {} }
  function gpStats(scope) {
    var all = gpLoad();
    var list = scope ? all.filter(function (r) { return r.product === scope; }) : all;
    var avg = list.length ? list.reduce(function (s, r) { return s + r.stars; }, 0) / list.length : 0;
    return { list: list, count: list.length, avg: avg };
  }

  /* PDP top rating button (real counts, links to #gp-reviews) */
  function ratingButton(root) {
    (root || document).querySelectorAll("[data-gp-ratingbtn]:not([data-rb])").forEach(function (b) {
      b.setAttribute("data-rb", "1");
      function paint() {
        var st = gpStats(b.getAttribute("data-scope") || "");
        if (st.count) {
          b.innerHTML = '<span class="gp-stars">' + starsSvg(Math.round(st.avg)) + '</span><strong>' + st.avg.toFixed(1) + '</strong><span>(' + st.count + ' review' + (st.count > 1 ? 's' : '') + ')</span>';
        } else {
          b.innerHTML = '<span class="gp-stars">' + starsSvg(0) + '</span><span>Be the first to review</span>';
        }
      }
      paint();
      document.addEventListener("gp:reviews", paint);
    });
  }

  function initReviews(root) {
    (root || document).querySelectorAll("[data-gp-reviews]:not([data-rv])").forEach(function (wrap) {
      wrap.setAttribute("data-rv", "1");
      var scope = wrap.getAttribute("data-scope") || "";
      var formProduct = wrap.getAttribute("data-form-product") || "";
      var form = wrap.querySelector("[data-rv-form]");
      var pick = wrap.querySelector("[data-rv-pick]");
      var list = wrap.querySelector("[data-rv-list]");
      var empty = wrap.querySelector("[data-rv-empty]");
      var summary = wrap.querySelector("[data-rv-summary]");
      var msg = wrap.querySelector("[data-rv-msg]");
      var rating = 0;
      var btns = pick ? [].slice.call(pick.querySelectorAll("button")) : [];
      function paintPick(n) { btns.forEach(function (b, i) { b.classList.toggle("is-on", i < n); }); }
      btns.forEach(function (b) {
        b.addEventListener("click", function () { rating = parseInt(b.getAttribute("data-val"), 10); paintPick(rating); });
        b.addEventListener("mouseenter", function () { paintPick(parseInt(b.getAttribute("data-val"), 10)); });
      });
      if (pick) pick.addEventListener("mouseleave", function () { paintPick(rating); });

      function render() {
        var st = gpStats(scope);
        var data = st.list;
        if (!data.length) {
          if (empty) empty.style.display = "";
          if (summary) summary.hidden = true;
          if (list) list.innerHTML = "";
          return;
        }
        if (empty) empty.style.display = "none";
        if (summary) {
          summary.hidden = false;
          summary.querySelector("[data-rv-avg]").textContent = st.avg.toFixed(1);
          summary.querySelector("[data-rv-avgstars]").innerHTML = starsSvg(Math.round(st.avg));
          summary.querySelector("[data-rv-count]").textContent = "(" + st.count + " review" + (st.count > 1 ? "s" : "") + ")";
        }
        if (list) list.innerHTML = data.slice().reverse().map(function (r) {
          var prod = (!scope && r.product) ? '<span class="gp-rv__prod">' + esc(r.product) + '</span>' : '';
          return '<div class="gp-rv__card"><div class="gp-stars">' + starsSvg(r.stars) + '</div>' + prod + '<p>' + esc(r.text) + '</p><div class="gp-rv__who"><b>' + esc(r.name) + '</b><span>' + esc(r.date) + '</span></div></div>';
        }).join("");
      }

      if (form) form.addEventListener("submit", function (e) {
        e.preventDefault();
        var name = form.name.value.trim(), text = form.text.value.trim();
        if (!rating) { if (msg) msg.textContent = "Please pick a star rating."; return; }
        if (!name || !text) { if (msg) msg.textContent = "Please add your name and review."; return; }
        var all = gpLoad();
        all.push({ name: name, text: text, stars: rating, product: formProduct, date: new Date().toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) });
        gpSave(all);
        form.reset(); rating = 0; paintPick(0);
        if (msg) msg.textContent = "Thanks! Your review has been added.";
        render();
        document.dispatchEvent(new Event("gp:reviews"));
      });

      render();
      document.addEventListener("gp:reviews", render);
    });
  }

  /* ---------- volume deal tiers ---------- */
  function tiers(root) {
    (root || document).querySelectorAll("[data-gp-tiers]:not([data-t])").forEach(function (box) {
      box.setAttribute("data-t", "1");
      var form = box.closest("form") || document.getElementById("gp-product-form");
      var qtyInput = form ? form.querySelector("[data-gp-qtyinput]") : null;
      var opts = [].slice.call(box.querySelectorAll("[data-tier]"));
      function select(o) {
        opts.forEach(function (x) { x.classList.remove("is-active"); });
        o.classList.add("is-active");
        if (qtyInput) qtyInput.value = o.getAttribute("data-qty") || "1";
        if (form) form.setAttribute("data-deal-url", o.getAttribute("data-url") || "");
      }
      opts.forEach(function (o) { o.addEventListener("click", function () { select(o); }); });
      var active = box.querySelector(".gp-tier.is-active") || opts[0];
      if (active) select(active);
      if (form && !form.getAttribute("data-deal-bound")) {
        form.setAttribute("data-deal-bound", "1");
        form.addEventListener("submit", function (e) {
          var url = form.getAttribute("data-deal-url");
          if (url) { e.preventDefault(); window.location.href = url; }
        });
      }
    });
  }

  /* ---------- hero cursor-follow glow ---------- */
  function heroGlow(root) {
    if (reduce) return;
    (root || document).querySelectorAll("[data-gp-hero]:not([data-hg])").forEach(function (h) {
      h.setAttribute("data-hg", "1");
      h.addEventListener("pointermove", function (e) {
        var r = h.getBoundingClientRect();
        h.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
        h.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
      });
    });
  }

  function boot(root) { reveal(root); counts(root); faq(root); sticky(root); pdpSticky(root); beforeAfter(root); anchors(root); qty(root); gallery(root); stickySubmit(root); initReviews(root); ratingButton(root); tiers(root); heroGlow(root); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
  else boot(document);
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
